import { useEffect } from "react";
import { trackEvent } from "../../mixpanel";

const webToken = process.env.REACT_APP_CHATWOOT_WEBSITE_TOKEN

const ChatWidget = () => {
  useEffect(() => {
    (function(d,t){
      var BASE_URL="https://app.chatwoot.com";
      var g=d.createElement(t), s=d.getElementsByTagName(t)[0];
      g.src=BASE_URL+"/packs/js/sdk.js";
      g.defer = true; g.async = true;
      s.parentNode.insertBefore(g, s);
      g.onload = function(){
        window.chatwootSDK.run({
          websiteToken: webToken,
          baseUrl: BASE_URL
        });

       window.addEventListener("chatwoot:ready", () => {
  // Wait a moment to ensure DOM inserts are complete
  setTimeout(() => {
    const launcher = document.querySelector('#cw-bubble-holder .woot-widget-bubble:not(.woot--close)');

    if (launcher) {
      launcher.addEventListener("click", () => {
        trackEvent("Chat Widget Opened", {
          page: window.location.pathname,
          opened_at: new Date().toISOString(),
          device: navigator.userAgent,
        });
      });
    }
  }, 1000);
});

      }
    })(document, "script");
  }, []);

  return null;
};

export default ChatWidget;
